import React, {Component} from 'react'
import server from '../server'
import PaymentGraph from '../graphs/PaymentGraph'
import MoneyGraph from '../graphs/MoneyGraph'

const styles = {
    p:{
        fontSize:12,
        fontWeight:"bold",
        marginBottom:"20px"
    },

    monthP:{
        fontSize:12,
        fontWeight:"bold",
        margin: "10px 10px",

    },

    h1:{
      fontSize:20,
      margin:0,
      marginLeft:10,
      textAlign:"left"
    },

    header:{
      margin:0,
      width:"100%",
      backgroundColor:"#00897b",
      padding:"20px 0px",
      color:"#FFFFFF",
      fontSize: 20,
      textAlign:"left",
      textAlign:"center"
    },

    div:{
      height: 'calc(100% - 69px)',
    },

    resume:{
      height: '100%',
      backgroundColor:"#eeeeee",
      padding:"10px 20px",
    },

    paper:{
      paddingBottom:5,
      margin: "auto",
      marginBottom: 20,
      width:"90%",
    }
}


class Financial extends Component{
    state = {
      months:[],
      tab: 0
    }

    componentDidMount(){
        this.loadPayments()
    }

    loadPayments = () =>{
      let component = [];
      let monthsLabel = ["","Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"]
      let months = {};
      let thisMonthReceived = 0;
      let thisMonthToReceive = 0;
      let thisMonthAppointments = 0;
      let totalAppointments = 0;
      let monthAppointments = 0;
      let price = 0
      let thisMonth = new Date();
      let thisYear = thisMonth.getFullYear();
      thisMonth = thisMonth.getMonth() + 1;

      let user_data = JSON.parse(localStorage.getItem("user"));
      let clinic_data = JSON.parse(localStorage.getItem("clinic"));
      this.setState({user_data:user_data,clinic_data:clinic_data})

      fetch(server.address + "/" + user_data.type + "/payments/" + user_data.id,{
        method:"GET",
        headers:{
            'Accept': 'application/json',
            'Content-Type':'application/json'
        },
      }).then(response => response.json().then(data => {
        for(let p in data.payments){
          let month = parseInt(data.payments[p].created_at.split("-")[1])
          if(months[month] == null){
            months[month] = {price: 0, appointments:0, toReceive: 0}
          }

          if(month == thisMonth) thisMonthAppointments += 1;
          months[month].appointments += 1;


          if(data.payments[p].confirmed){
            if(month == thisMonth) thisMonthReceived += data.payments[p].value;
            months[month].price += data.payments[p].value;
          }else{
            if(month == thisMonth) thisMonthToReceive += data.payments[p].value;
            months[month].toReceive += data.payments[p].value;
          }
        }
        console.log(thisMonthAppointments)
        this.setState({thisMonthAppointments:thisMonthAppointments});

        for(var month in months){
          component.push(
            <div style={styles.paper}>
              <div style={styles.header}><h1 style={styles.h1}>{monthsLabel[month]}/2018</h1></div>
              <p style={styles.monthP}>Total Arrecadado: R$ {months[month].price},00</p>
              <p style={styles.monthP}>Total Para Receber: R$ {months[month].toReceive},00</p>
              <p style={styles.monthP}>Número de agendamentos atendidos: {months[month].appointments}</p>
            </div>)
        }
        console.log(thisMonth);

        this.setState({yearLabel:thisYear,monthLabel: monthsLabel[thisMonth],monthReceive:thisMonthReceived,
                       monthToReceive:thisMonthToReceive,months:component, totalAppointments: totalAppointments, 
                       monthAppointments:monthAppointments,price:price});
      }));
    }

      render(){
        return(
          <div class="col1-app">
            <div class="col1-app__wrapper">
                <div class="col1-list h-100p">
                    <div class="peers w-100p ai-c jc-sb content-header">
                        <div class="content-header__left">
                            <button type="button" class="page-side-toggle d-n@md+ btn btn-clear pX-5 pY-0  bdrs-2 mR-10 cur-p c-client-secondary">
                                <i class="material-icons">vertical_split</i>
                            </button>
                            <div class="content-header__title">
                                <h3 class="m-0">
                                    Financeiro
                                </h3>
                            </div>
                        </div>
                        <div class="btn-group" role="group">
                            <button class="btn btn-clear pX-5 pY-0 bdrs-2 mR-5 cur-p  c-client-default" type="button">
                                <i class="fa fa-trash fsz-xl"></i>
                            </button>
                            <button class=" d-n@md+ btn btn-clear pX-5 pY-0 bdrs-2 mR-3 cur-p  c-client-default" type="button">
                                <i class="fa fa-plus-circle fsz-xl"></i>
                            </button>
                        </div>
                    </div>
                    <div class="scrollable h-100p">
                        <div class="inner-scrollable-data">
                            <div class="col-md-12 pY-20">
                            <h3 class="pX-20 pY-10">Statísticas</h3>
                                <div class="col-sm-4 mB-10">
                                    <div class="bdrs-2 w-100p bd  cur-p open-details">
                                        <div>
                                            <i class="fa fa-money fsz-xl c-client-secondary pX-20 pT-20 pB-0"></i>
                                        </div>
                                        <div class="client-info pX-20 pT-0 pB-20">
                                            <h5 class="c-client-default">
                                                <b>Total arrecadado</b>
                                            </h5>
                                            <hr class="small m-0"/>
                                            <div class="peers ai-c jc-sb">
                                                <div>
                                                    <span class="c-client-secondary fsz-xs">{this.state.monthLabel} de {this.state.yearLabel}</span>
                                                    <h3 class="m-0">R$ {this.state.monthReceive},00</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-4 mB-10">
                                    <div class="bdrs-2 w-100p bd  cur-p open-details">
                                        <div>
                                            <i class="fa fa-download fsz-xl c-client-secondary pX-20 pT-20 pB-0"></i>
                                        </div>
                                        <div class="client-info pX-20 pT-0 pB-20">
                                            <h5 class="c-client-default">
                                                <b>Total à receber</b>
                                            </h5>
                                            <hr class="small m-0"/>
                                            <div class="peers ai-c jc-sb">
                                                <div>
                                                    <span class="c-client-secondary fsz-xs">{this.state.monthLabel} de {this.state.yearLabel}</span>
                                                    <h3 class="m-0">R$ {this.state.monthToReceive},00</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-4 mB-10">
                                    <div class="bdrs-2 w-100p bd  cur-p open-details">
                                        <div>
                                            <i class="fa fa-stethoscope fsz-xl c-client-secondary pX-20 pT-20 pB-0"></i>
                                        </div>
                                        <div class="client-info pX-20 pT-0 pB-20">
                                            <h5 class="c-client-default">
                                                <b>Total Atendimentos</b>
                                            </h5>
                                            <hr class="small m-0"/>
                                            <div class="peers ai-c jc-sb">
                                                <div>
                                                    <span class="c-client-secondary fsz-xs">{this.state.monthLabel} de {this.state.yearLabel}</span>
                                                    <h3 class="m-0">{this.state.thisMonthAppointments}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                    <div class="col-sm-6 mB-10">
                                        <div class="bdrs-2 w-100p bd">
                                            <div class="p-20 peers  ai-c jc-sb">
                                                <div>
                                                    <h5 class="c-client-default">
                                                        <b>Pagamentos</b>
                                                    </h5>
                                                    <hr class="small m-0"/>
                                                </div>
                                                <button class="open-details btn btn-clear pX-5 pY-0 bdrs-2 mR-5 cur-p  c-client-default" type="button">
                                                    <i class="fa fa-ellipsis-h fsz-xl"></i>
                                                </button>
            
                                            </div>
                                            <div class="client-info pX-20 pT-0 pB-20">
                                                <div class="peers ai-c jc-sb">
                                                  <PaymentGraph/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                <div class="col-sm-6 mB-10">
                                        <div class="bdrs-2 w-100p bd">
                                            <div class="p-20 peers  ai-c jc-sb">
                                                <div>
                                                    <h5 class="c-client-default">
                                                        <b>Ganhos</b>
                                                    </h5>
                                                    <hr class="small m-0"/>
                                                </div>
                                                <button class="open-details btn btn-clear pX-5 pY-0 bdrs-2 mR-5 cur-p  c-client-default" type="button">
                                                    <i class="fa fa-ellipsis-h fsz-xl"></i>
                                                </button>
            
                                            </div>
                                            <div class="client-info pX-20 pT-0 pB-20">
                                                <div class="peers ai-c jc-sb">
                                                    <MoneyGraph/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
      }
}

export default Financial



// WEBPACK FOOTER //
// ./src/pages/Financial.js